// extracted by mini-css-extract-plugin
export default {"or":"userPropertySelector_or__puY-A","options":"userPropertySelector_options__An7fA"};